import moment from 'moment-timezone';
import * as XlsxPopulate from 'xlsx-populate/browser/xlsx-populate.js';
import { date_utils } from './date_utils';
import { I18nBase } from './i18n.base';
let titleStyle = {
  bold: true,
  fontSize: 18
  // fill: 'cccccc',
};
export interface XlsUtilsColumn {
  id?:string;
  path: string;
  name: string;
  f?: (path, v: any) => any;
  style?: {
    format: string;
    pattern: string;
  };
}
export class XlsUtils {
  static webExport(
    workbook: XlsxPopulate.Workbook,
    cb?: () => void,
    opts?: { filename?: string }
  ) {
    opts = opts || {};
    workbook.outputAsync().then((blob) => {
      if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
        // If IE, you must uses a different method.
        (window.navigator as any).msSaveOrOpenBlob(
          blob,
          opts.filename || 'export.xlsx'
        );
      } else {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.href = url;
        a.download = opts.filename || 'export.xlsx';
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 2000);
        document.body.removeChild(a);
      }
      if (cb) cb();
    });
  }

  static dateFormat = {
    format: 'numberFormat',
    pattern: 'yyyy-mm-dd',
  };
  static timeFormat = {
    format: 'numberFormat',
    pattern: 'yyyy-mm-dd hh:MM',
  };
  static dataNameEn(path, cell) {
    const columnKeys = path.split('.');
    for (const columnKey of columnKeys) {
      if (!cell[columnKey]) return '';
      else cell = cell[columnKey];
    }

    return I18nBase.get('en', cell?.name, cell?.name_lang);
  }
  static dataNameZh(path, cell) {
    const columnKeys = path.split('.');
    for (const columnKey of columnKeys) {
      if (!cell[columnKey]) return '';
      else cell = cell[columnKey];
    }

    return I18nBase.get('zh_hk', cell?.name, cell?.name_lang);
  }
  static dataZero(path, cell) {
    const columnKeys = path.split('.');
    for (const columnKey of columnKeys) {
      if (cell?.[columnKey] == null) return 0;
      else cell = cell[columnKey];
    }

    return cell ?? 0;
  }
  static dataBool(path, cell) {
    const columnKeys = path.split('.');
    for (const columnKey of columnKeys) {
      if (cell?.[columnKey] == null) return false;
      else cell = cell[columnKey];
    }

    return cell ?? false;
  }
  static data(path, cell) {
    const columnKeys = path.split('.');
    for (const columnKey of columnKeys) {
      if (cell?.[columnKey] == null) return '';
      else cell = cell[columnKey];
    }
    return cell;
  }
  static dataList(path, cell) {
    const columnKeys = path.split('.');
    for (const columnKey of columnKeys) {
      if (cell[columnKey] == null) return '';
      else cell = cell[columnKey];
    }
    if (Array.isArray(cell)) {
      return cell.join(',')
    } else {
      return cell ?? ''
    }

  }
  static dataObjectNameList(path, cell) {
    const columnKeys = path.split('.');
    for (const columnKey of columnKeys) {
      if (cell[columnKey] == null) return '';
      else cell = cell[columnKey];
    }
    if (Array.isArray(cell)) {
      return cell.map((c) => c.name).join(',')
    } else {
      return cell ?? ''
    }

  }
  static dataDate(path, cell) {
    const columnKeys = path.split('.');
    for (const columnKey of columnKeys) {
      if (cell[columnKey] == null) return '';
      else cell = cell[columnKey];
    }
    return cell?.toDate() ?? '';
  }
  static dataDateUtc(path, cell) {
    const columnKeys = path.split('.');
    for (const columnKey of columnKeys) {
      if (cell[columnKey] == null) return '';
      else cell = cell[columnKey];
    }
    if (!cell) {
      return '';

    }
    return date_utils.momentUTCToLocalDate(moment(cell)).toDate();
  }
  static rowData(columns: XlsUtilsColumn[], t: any) {
    return columns.map((col) => {
      let f = col.f;
      if (f) return f(col.path, t);
      return this.data(col.path, t);
    });
  }
  static row(
    sheet: XlsxPopulate.Sheet,
    row: number,
    columns: XlsUtilsColumn[],
    t: any
  ) {
    let data = XlsUtils.rowData(columns, t);
    sheet.cell(row, 1).value([data]);

    for (let i = 0; i < columns.length; i++) {
      let c = columns[i];
      if (c.style) {
        sheet.cell(row, i + 1).style(c.style.format, c.style.pattern);
      }
    }
  }

  static exportHeader(sheet: XlsxPopulate.Sheet,
    columns: XlsUtilsColumn[],
    row: number,
    opts?: {
      title: string,
      start: moment.Moment,
      end: moment.Moment,
    }) {
    if (opts?.title) {
      let cell = sheet.cell(row++, 1)
      cell.value([[opts.title]]);
      cell.style(titleStyle);
    }
    if (opts?.start && opts?.end) {
      let s = `${opts.start.format('YYYY-MM-DD')} - ${opts.end.format('YYYY-MM-DD')}`
      let cell = sheet.cell(row++, 1)
      cell.value([[s]]);
      cell.style(titleStyle);
    }
    sheet.cell(row++, 1).value([columns.map((c) => c.name)]);
    return row;
  }

  static exportSheet(
    sheet: XlsxPopulate.Sheet,
    list: any[],
    columns: XlsUtilsColumn[],
    opts?: {
      title: string,
      start: moment.Moment,
      end: moment.Moment,
    }
  ) {
    let row = 1;
    row = this.exportHeader(sheet, columns, row, opts);

    for (const t of list) {
      XlsUtils.row(sheet, row, columns, t);
      row++;
    }

  }
}
